import { createReducer } from '@reduxjs/toolkit'

import { updateVersion } from '../global/actions'
import { toggleURLWarning, updateMatchesDarkMode, updateUserDarkMode } from './actions'

const currentTimestamp = () => new Date().getTime()

export interface UserState {
  lastUpdateVersionTimestamp?: number
  userDarkMode: boolean | null
  matchesDarkMode: boolean
  URLWarningVisible: boolean
  timestamp: number
}

export const initialState: UserState = {
  URLWarningVisible: true,
  matchesDarkMode: false,
  userDarkMode: null,
  timestamp: currentTimestamp()
}

export default createReducer(initialState, builder =>
  builder
    .addCase(updateVersion, state => {
      state.lastUpdateVersionTimestamp = currentTimestamp()
    })
    .addCase(updateUserDarkMode, (state, action) => {
      state.userDarkMode = action.payload.userDarkMode
      state.timestamp = currentTimestamp()
    })
    .addCase(updateMatchesDarkMode, (state, action) => {
      state.matchesDarkMode = action.payload.matchesDarkMode
      state.timestamp = currentTimestamp()
    })
    .addCase(toggleURLWarning, state => {
      state.URLWarningVisible = !state.URLWarningVisible
    })
)
